import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Container } from 'components/GridV2';
import { Close } from 'components/icons';

import { trackEvent, useIsTabletSize } from 'helpers';

type Props = {
  children: ReactNode;
  className?: string;
  handleClose: () => void;
  trackName: string;
};

export const LongBanner = ({ children, className, handleClose, trackName }: Props) => {
  const isTablet = useIsTabletSize();
  const closeButton = (
    <button
      className="-mr-16 mt-8 flex h-fit items-center justify-center p-6 lg:absolute lg:right-8 lg:mr-0 lg:mt-0 lg:h-full"
      onClick={() => {
        handleClose();
        trackEvent('Clicked', { name: trackName });
      }}
    >
      <Close className="scale-[83%]" />
    </button>
  );

  return (
    <div
      className={twMerge(
        'relative flex h-fit bg-primary-350 text-white [box-shadow:0px_4px_4px_#00000003] lg:h-44',
        className,
      )}
    >
      <Container className="flex h-full justify-between gap-12 px-32 xs:px-0 lg:items-center lg:justify-center">
        <div className="flex h-full flex-col gap-4 py-16 lg:flex-row lg:items-center lg:justify-center lg:gap-0 lg:py-0">
          {children}
        </div>
        {isTablet && closeButton}
      </Container>
      {!isTablet && closeButton}
    </div>
  );
};
